export const money = (n) => `$${Number(n || 0).toLocaleString("en-US")} USD`;
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("es", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("es", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export const LEVEL_LABELS = { 1: "1er nivel", 2: "2º nivel", 3: "3er nivel", 4: "4º nivel", 5: "5º nivel" };

export const STATUS_STYLES = {
  activa: "bg-leaf/20 text-leaf-deep",
  pendiente: "bg-sun/30 text-[#6b4f00]",
  aprobado: "bg-leaf/20 text-leaf-deep",
  rechazado: "bg-coral/15 text-coral",
  pagada: "bg-leaf/20 text-leaf-deep",
};

export const STATUS_LABELS = {
  activa: "Membresía activa",
  pendiente: "Pendiente",
  aprobado: "Aprobado",
  rechazado: "Rechazado",
  pagada: "Pagada",
};

export const Badge = ({ status, label, testId }) => (
  <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${STATUS_STYLES[status] || "bg-ink/10 text-ink"}`} data-testid={testId}>
    {label || STATUS_LABELS[status] || status}
  </span>
);

export const StatCard = ({ label, value, dark, testId, hint }) => (
  <div className={`rounded-2xl p-5 ${dark ? "bg-ink text-white" : "border border-ink/10 bg-white"}`} data-testid={testId}>
    <p className="font-display text-3xl font-semibold tracking-tight sm:text-4xl">{value}</p>
    <p className={`mt-1 text-sm ${dark ? "text-[#AEB7D3]" : "text-ink/70"}`}>{label}</p>
    {hint && <p className={`mt-1 text-xs ${dark ? "text-[#AEB7D3]/80" : "text-ink/50"}`}>{hint}</p>}
  </div>
);

export const PanelTitle = ({ title, text, children }) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h2 className="font-display text-3xl font-semibold tracking-tight">{title}</h2>
      {text && <p className="mt-1 max-w-2xl text-sm text-ink/70">{text}</p>}
    </div>
    {children}
  </div>
);

export const Table = ({ headers, children, testId, minWidth = "min-w-[800px]" }) => (
  <div className="mt-5 overflow-x-auto rounded-2xl border border-ink/10 bg-white">
    <table className={`w-full ${minWidth} text-left text-sm`} data-testid={testId}>
      <thead className="border-b border-ink/10 bg-paper/70 text-xs uppercase tracking-[0.06em] text-ink/70">
        <tr>{headers.map((h, i) => <th key={i} className="px-4 py-3 font-semibold">{h}</th>)}</tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  </div>
);

export const EmptyRow = ({ cols, text, testId }) => (
  <tr><td colSpan={cols} className="px-4 py-10 text-center text-ink/70" data-testid={testId}>{text}</td></tr>
);

export const shortHash = (h) => (h ? `${h.slice(0, 8)}…${h.slice(-6)}` : "—");

export const VERIFICATION_LABELS = {
  ok: "Verificado en blockchain · pendiente de confirmación del administrador",
  pendiente_o_no_encontrada: "La red aún no confirma la transacción. Vuelve a verificar en unos minutos.",
  transaccion_revertida: "La transacción fue revertida en la red.",
  sin_transferencia_a_la_wallet: "No encontramos una transferencia a nuestra wallet en esa transacción.",
  monto_insuficiente: "El monto transferido es menor a $299.",
  hash_invalido: "El hash no tiene un formato válido.",
  rpc_no_disponible: "No pudimos consultar la red en este momento. El admin revisará tu comprobante.",
  rpc_error: "La red devolvió un error. El admin revisará tu comprobante.",
};
